import React from 'react'

function B10() {
    return (
        <div>
            <h1>Great!</h1>
        </div>
    )
}

export default B10